<template>
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon">
      <path
        id="Icon_2"
        d="M8 50.6663V26.854C8 25.0707 8.89121 23.4055 10.3749 22.4163L29.0416 9.9719C30.8331 8.77759 33.1669 8.77759 34.9584 9.9719L53.6251 22.4163C55.1088 23.4055 56 25.0707 56 26.854V50.6663M8 50.6663C8 53.6118 10.3878 55.9996 13.3333 55.9996H50.6667C53.6122 55.9996 56 53.6118 56 50.6663M8 50.6663L26 38.6663M56 50.6663L38 38.6663M8 26.6663L26 38.6663M56 26.6663L38 38.6663M38 38.6663L34.9584 40.694C33.1669 41.8883 30.8331 41.8883 29.0416 40.694L26 38.6663"
        stroke="#113841"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
